module.exports = __webpack_public_path__ + "img/矢量智能对象拷贝6.0266a9e1.png";